import { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import cx from "classnames";

import styles from "./styles.module.css";

type MarkdownProps = {
  markup: string;
  className?: string;
  openLinksInNewTab?: boolean;
};

const Markdown = forwardRef(function Markdown(
  props: MarkdownProps,
  ref: React.ForwardedRef<HTMLElement>
) {
  const { openLinksInNewTab = false } = props;

  return (
    <section ref={ref} className={cx(styles.markdownBody, props.className)}>
      <ReactMarkdown
        remarkPlugins={[gfm]}
        skipHtml
        components={{
          a: ({ href, children, ...anchorProps }) => {
            const isExternal = href?.startsWith("http://") || href?.startsWith("https://");
            const shouldOpenInNewTab = openLinksInNewTab && isExternal;

            return (
              <a
                href={href}
                {...anchorProps}
                {...(shouldOpenInNewTab && { target: "_blank", rel: "noopener noreferrer" })}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {props.markup}
      </ReactMarkdown>
    </section>
  );
});

export default Markdown;
